<template>
  <form @submit.prevent="handleSubmit">
    <modal-card title="Add Activation" style="margin: 0 auto;" contains-dropdown>
      <b-field label="Add Activation Type">
        <b-select v-model="form.type" expanded>
          <option value="all" selected>All</option>
          <option value="magazine">Magazine</option>
          <option value="issue">Issue</option>
        </b-select>
      </b-field>

      <b-field label="User">
        <user-select @change="user => (form.user_id = user.id)"></user-select>
      </b-field>

      <b-field label="Magazine" v-if="form.type=='magazine'">
        <magazine-select v-model="form.magazine_id" clearable></magazine-select>
      </b-field>

      <b-field label="Issue" v-if="form.type=='issue'">
        <magazine-issue-select v-model="form.issue_id" :magazine-id="form.magazine_id"></magazine-issue-select>
      </b-field>

      <b-field label="Note">
        <b-input v-model="form.note" placeholder="note"></b-input>
      </b-field>

      <div slot="foot">
        <button type="button" class="button" @click="$parent.close()">
          Close
        </button>

        <button
          class="button is-primary"
          :class="{ 'is-loading': form.processing }"
        >
          Add Activation
        </button>
      </div>
    </modal-card>
  </form>
</template>

<script>
import UserSelect from "@/modules/admin/components/selectors/UserSelect";

export default {
  components: {
    UserSelect
  },

  props: {
    added: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      form: new window.Form({
        type: 'all',
        note: null,
        user_id: null,
        issue_id: null,
        magazine_id: null
      })
    };
  },

  methods: {
    handleSubmit() {
      this.form.post("/admin/api/magazine/complementary-accesses").then(this.whenAdded);
    },

    whenAdded() {
      this.added();

      this.$buefy.toast.open("New manager has been added.");

      this.$parent.close();
    }
  }
};
</script>
